var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.556,
    height: 47,
    viewBox: "0 0 36.556 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01-home",
    "data-name": "01-home",
    transform: "translate(-60 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(60 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55640",
    "data-name": "Path 55640",
    d: "M78.278,4A18.3,18.3,0,0,0,60,22.278c0,4.9,2.966,11.183,8.816,18.686A99.39,99.39,0,0,0,77.5,50.69a1.119,1.119,0,0,0,1.547,0,99.392,99.392,0,0,0,8.688-9.726c5.85-7.5,8.816-13.79,8.816-18.686A18.3,18.3,0,0,0,78.278,4Zm0,31.333A13.056,13.056,0,1,1,91.333,22.278,13.07,13.07,0,0,1,78.278,35.333Z",
    transform: "translate(-60 -4)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55641",
    "data-name": "Path 55641",
    d: "M174.284,107.752l-8.206-7.46a1.119,1.119,0,0,0-1.505,0l-8.206,7.46a1.12,1.12,0,0,0-.208,1.4,1.15,1.15,0,0,0,.994.545h1.086v7.087a1.119,1.119,0,0,0,1.119,1.119h2.611a1.119,1.119,0,0,0,1.119-1.119v-4.1a1.119,1.119,0,0,1,1.119-1.119h2.238a1.119,1.119,0,0,1,1.119,1.119v4.1a1.119,1.119,0,0,0,1.119,1.119h2.611a1.119,1.119,0,0,0,1.119-1.119V109.7H173.5a1.15,1.15,0,0,0,.994-.545A1.12,1.12,0,0,0,174.284,107.752Z",
    transform: "translate(-147.047 -91.048)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderLocation);
export default __webpack_public_path__ + "static/media/profile-builder-location.e49c8aa99ab0bb8104649e3e3ac14487.svg";
export { ForwardRef as ReactComponent };